export interface SpeakOptions { lang?: string; rate?: number; pitch?: number; }

/** Returns the first it-IT voice, or null if none/unavailable. */
export function pickItalianVoice(): SpeechSynthesisVoice | null {
  if (typeof window === 'undefined' || !window.speechSynthesis) return null;
  const voices = window.speechSynthesis.getVoices();
  const it = voices.find((v) => v.lang === 'it-IT') ?? voices.find((v) => v.lang.startsWith('it'));
  return it ?? null;
}

export function isTtsAvailable(): boolean {
  return typeof window !== 'undefined' && !!window.speechSynthesis && pickItalianVoice() !== null;
}

export function speak(text: string, opts: SpeakOptions = {}): void {
  if (!isTtsAvailable()) return;
  const utter = new window.SpeechSynthesisUtterance(text);
  const voice = pickItalianVoice();
  if (voice) {
    utter.voice = voice;
    utter.lang = voice.lang;
  } else {
    utter.lang = opts.lang ?? 'it-IT';
  }
  if (opts.rate !== undefined) utter.rate = opts.rate;
  if (opts.pitch !== undefined) utter.pitch = opts.pitch;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utter);
}
